import React from 'react';
import { StyleSheet, View, type ViewProps } from 'react-native';
import { useStyle } from 'react-native-style-utilities';

import { theme, useContainerSpacing, useResponsive } from '@sg/garnish';

export const FlexLandingPageContent = (props: ViewProps) => {
  const { match } = useResponsive();
  const paddingHorizontal = useContainerSpacing();
  const spacingSM = useStyle(() => ({ paddingHorizontal }), [paddingHorizontal]);
  const spacingStyle = match([styles.spacingXS, spacingSM]);

  return <View style={[spacingStyle, props.style]}>{props.children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  spacingXS: {
    paddingHorizontal: theme.spacing['4'],
  },
});
